import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'

import { user } from 'ampersand-app'
import getUploader from '@/modules/file/uploader'

import todoConfig from '@/modules/todo/config'
import SimpleDrawer from '@/components/drawers/simple-drawer'

import lang from '@/lang'
import { toast } from '@/modules/base/components/toast/toastConfig'
import handleUploadError from '@/modules/file/_helpers/handleUploadError'
import validateFileName from '@/utils/validateFileName'
import FileUploadChooser from '@/components/controls/file-upload-chooser'
import { FILE_LIST_FILTER } from '@/modules/base/util/constants'
import DashboardTodoFileListComponent from '@/modules/dashboard/view/dashboard-todo-file-list.component'
import ThemeInterface from '@/theme-interface'
import todoTypesEnum from '@/enums/todo-types.enum'

const ALLOWED_FILE_EXTENSIONS = ['pdf']

const useStyles = makeStyles((theme: ThemeInterface) => ({
  fileList: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
  description: {
    maxWidth: 400,
    paddingBottom: 30,
  },
  fileChooser: {
    backgroundColor: theme.backgroundColor,
    '& .title': {
      fontSize: 14,
      padding: 0,
      margin: 0,
    },
    '& .subTitle': {
      fontSize: 12,
      lineHeight: 'unset',
    },
    '& .special': {
      fontWeight: 400,
    },
  },
}), { name: 'SignatureDocumentSelection' })

const SignatureDocumentSelection = (props) => {
  const classes = useStyles()
  const { onFileSelected, tenantCollaborationId, filter = FILE_LIST_FILTER.ONLY_DOCUMENTS } = props
  const [isFileContainerOpen, setIsFileContainerOpen] = useState(false)

  const openFileContainer = () => {
    setIsFileContainerOpen(true)
  }
  const closeFileContainer = () => {
    setIsFileContainerOpen(false)
  }
  const onSelectFromFileContainer = (file) => {
    setIsFileContainerOpen(false)
    onFileSelected && onFileSelected({ ...file, file, source: 'container' })
  }

  const onFileUploadError = (id, name, errorReason, xhr) => {
    handleUploadError(xhr, errorReason)
  }

  const onFileUploadCompleted = (id, name, response) => {
    if (!response?.success) { return }

    const file = uploader.methods.getFile(id)
    const reader = new FileReader()
    reader.onabort = () => {
      toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
    }
    reader.onerror = () => {
      toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
    }
    reader.onload = () => {
      const data = reader.result
      onFileSelected && onFileSelected({ data, file, source: 'upload' })
    }
    reader.readAsDataURL(file)
  }

  const uploader = getUploader({
    messages: {
      typeError: lang.fileUploaderTypesError.replace('%s', 'pdf'),
    },
    autoUpload: true,
    callbacks: {
      onError: onFileUploadError,
      onComplete: onFileUploadCompleted,
      onValidate: (file) => validateFileName(file),
    },
    validation: {
      acceptFiles: ['application/pdf'],
      allowedExtensions: ['pdf'],
    },
    request: {
      endpoint: todoConfig.uploadUrl,
      customHeaders: { authorization: `Bearer ${user?.token}` },
      inputName: 'file',
      params: { todoType: todoTypesEnum.SIGNATURE },
    },

  })

  return (
    <>
      <SimpleDrawer
        className={classes.fileList}
        open={isFileContainerOpen}
        enableBackdropClick
        onClose={closeFileContainer}
        headline={lang.todo.uploader.title} >
        <DashboardTodoFileListComponent
          tenantCollaborationId={tenantCollaborationId}
          filter={filter}
          onClose={closeFileContainer}
          onSelect={onSelectFromFileContainer} />
      </SimpleDrawer>
      <div className={classes.description}>
        {lang.signature.documentSelection.description}
      </div>
      <FileUploadChooser
        uploader={uploader}
        multiple={false}
        title={lang.fileUploadChooser.title}
        uploadLabel={lang.fileUploadChooser.uploadLabel}
        fileContainerLabel={lang.fileUploadChooser.fileContainerLabel}
        accept={ALLOWED_FILE_EXTENSIONS}
        onOpenFileContainer={openFileContainer}
        className={classes.fileChooser}>
      </FileUploadChooser>
    </>
  )
}

export default SignatureDocumentSelection
